class AnonymousAuth {
  authorize() {
    // do nothing with request
  }
}

module.exports = AnonymousAuth;
